import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { SketchComponent } from './sketch/sketch.component';
import {EsriExpand, EsriReactiveUtils} from '../../../config/esri.module';
import { TranslateService } from '@ngx-translate/core';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
    selector: 'draw',
    templateUrl: './draw.component.html',
    styleUrls: ['draw.component.scss'],
    standalone: false
})
export class DrawComponent extends BaseWidget implements OnInit, AfterViewInit {
  @ViewChild(SketchComponent, { static: true })
  private _sketchComponent: SketchComponent;
  @ViewChild('drawComponentRef', { static: true }) drawComponentRef: ElementRef;
  private _mapView: __esri.MapView;
  public widgetToolTip: string;

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService,
    private _translate: TranslateService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  /**
   * @name ngOnInit
   * @description Creates expand-widget and a draw-instance and subscribes the listeners
   */
  ngOnInit() {
    this._mapView = this.mainMapService.mapView;

    // translate tooltip
    this._translate.get('WIDGET.DRAW.TOOLTIP').subscribe(msg => {
      this.widgetToolTip = msg;
    });

    // create an expand instance
    const expandProperties: __esri.ExpandProperties = {
      view: this._mapView,
      id: 'DrawComponent',
      content: this.drawComponentRef.nativeElement,
      expandIcon: 'pencil',
    };
    this.expandWidget = new EsriExpand(expandProperties);
    // translate tooltip icon
    super.translateToolTipWidgetIcon(this.expandWidget, this._translate, 'WIDGET.DRAW.TOOLTIP');

    // expand widget on create
    if (this.expandOnInit) {
      this.expandWidget.expand();
    }

    EsriReactiveUtils.watch(
      () => this.expandWidget?.expanded,
      () => {
        this.onExpandChanged();
      }
    );

    // add and widget to the main map
    // do not register widget on map because this widget should not be closed on map click
    this._mapView.ui.add(this.expandWidget, 'top-right');
  }

  ngAfterViewInit() {
    // listen on language change
    this._translate.onLangChange.subscribe(() => {
      super.translateToolTipWidgetIcon(this.expandWidget, this._translate, 'WIDGET.DRAW.TOOLTIP');
    });
  }

  /**
   * @name onExpandChanged
   * @description Closes all other widgets and deactivate create-tool
   */
  private onExpandChanged() {
    this._sketchComponent.deactivate(true);
    if (this.expandWidget.expanded) {
      this.mainMapService.closeOtherWidgets(this.expandWidget);
      this.mainMapService.deactivateMapInteraction();
    }
  }

}
